import { render, staticRenderFns } from "./DeedResult.vue?vue&type=template&id=54588be1&scoped=true&"
import script from "./DeedResult.vue?vue&type=script&lang=js&"
export * from "./DeedResult.vue?vue&type=script&lang=js&"
import style0 from "./DeedResult.vue?vue&type=style&index=0&id=54588be1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54588be1",
  null
  
)

export default component.exports